export default {
  namespaced: true,
  state: undefined,
  mutations: {
    saveFormProgression(state, payload) {
      if (state === undefined) {
        state = {};
      }
      state[payload.form] = payload.value;
    },
  },
};
